import React, { memo } from "react";
import PropTypes from "kf-proptypes/widgets";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

function DurationNormal(props) {
  const { startTime, endTime, duration } = props;
  if (startTime && endTime) {
    return (
      <React.Fragment>
        {formatDuration(dayjs(endTime).diff(startTime, "seconds"))}
      </React.Fragment>
    );
  }
  return <React.Fragment>{formatDuration(duration)}</React.Fragment>;
}
DurationNormal.propTypes = {
  /** Start time is prop here start time and end to minus value will be taken as seconds and convert as days months years  */
  startTime: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * End time is prop here start time and end to minus value will be taken as seconds and convert as days months years
   */
  endTime: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * Duration is a props takes seconds as input
   */
  duration: PropTypes.number
};
DurationNormal.displayName = "Duration";

export const Duration = memo(DurationNormal);

export function formatDuration(duration) {
  if (duration < 3600) {
    return humanizeDuration(dayjs.duration(duration, "seconds"));
  } else if (duration < 86400) {
    return humanizeDuration(
      dayjs.duration(Math.round(duration / 60), "minutes")
    );
  } else {
    return humanizeDuration(
      dayjs.duration(Math.round(duration / 3600), "hours")
    );
  }
}

function humanizeDuration(duration) {
  let seconds = duration.seconds();
  let minutes = duration.minutes();
  let hours = duration.hours();
  let days = duration.days();
  let months = duration.months();
  let years = duration.years();

  let readableString = "";
  if (years) {
    readableString += `${years}y `;
  }

  if (months) {
    readableString += `${months}mo `;
  }

  if (days) {
    readableString += `${days}d `;
  }

  if (hours) {
    readableString += `${hours}h `;
  }

  if (minutes) {
    readableString += `${minutes}m `;
  }

  if (seconds) {
    readableString += `${seconds}s `;
  }

  return readableString;
}
